
const codes = {
    "white": [255,255,255],
    "black": [0,0,0],
};

export const getColorCodes = (name) => codes[name];